import classNames from 'classnames'
import Icon from './Icon'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class ToggleSwitch extends Component {
  static propTypes = {
    className: PropTypes.string,
    expanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    style: PropTypes.object
  }

  shouldComponentUpdate(nextProps) {
    return this.props.expanded !== nextProps.expanded
  }

  render() {
    const { className, expanded, onClick, style } = this.props
    const classes = classNames(
      {
        plus: !expanded,
        minus: expanded
      },
      className
    )

    return <Icon name={classes} onClick={onClick} style={style} />
  }
}



// WEBPACK FOOTER //
// ../src/components/ToggleSwitch.js